
import { Options, Vue } from 'vue-class-component';
import NModalWindow, { NModalWindowSize } from '@/uikit/modal-window/NModalWindow.vue';
import NButton from '@/uikit/buttons/NButton.vue';
import { Remarkable } from 'remarkable';
import NCheckbox from '@/uikit/checkbox/NCheckbox.vue';
const remarkable = new Remarkable();

@Options({
  name: 'LicenseAgreement',
  components: {
    NCheckbox,
    NModalWindow,
    NButton
  }
})
export default class LicenseAgreement extends Vue {
  private licenseAccept = false;

  get size() {
    return NModalWindowSize.Large;
  }

  toHtml(v: any) {
    return remarkable.render(v);
  }

  proceedHandler() {
    this.licenseAccept && this.$emit('proceed');
  }
}
